/**
 *
 */

//定义服务器相关接口

var server = "https://www.yixianglife.com/yxlife_new/?";



//定义API接口地址
var api = {
	//登录
	user_login: server + "m=service&c=user&a=login",
	//注销
	user_loginOut: server + "m=service&c=user&a=logout",
	//实时查询账户情况
	user_selectssinfo: server + "m=service&c=user&a=selectssinfo",
	// 债权悬赏
	Assignment: server+'m=service&c=collection&a=releasecollection1',
	// 三级联动
	getcity: server+'m=service&c=collection&a=getCity',
	// 获取法院专栏
	get_my_type: server+'m=service&c=court&a=get_my_type',
	// 添加法院专栏配图
	add_court_column : server+'m=service&c=court&a=add_court_column',

	
	

};



export {
	api
}


// WEBPACK FOOTER //
// ./src/service/common.js